import renderAndEnableListingTiles from '../listing_tile_rendering/listingTileRenderer'
import { buildFilters, initiateSearch } from '../../utils/search/helpers'
import { onVisible } from '../utils'

// TODO: Check whether moreFromThisSeller is really required
// TODO: source: PropTypes.string, // not sure it's use.
// saw being used to see if 'Wishlist' and change things
// was is it being used perhaps by some tracking?
// render at a level and at img level... why. double check later...
// don't see this in particular being used.. see other sources being used though

export default function initViewMoreListingsModules () {
  const viewMoreListingsContainers = document.querySelectorAll('.vjs-view-more-listings')

  viewMoreListingsContainers.forEach(viewMoreContainer => {
    if (viewMoreContainer.dataset.lazyLoaded === 'true') {
      onVisible(viewMoreContainer, loadListingsIntoModule)
    } else {
      loadListingsIntoModule(viewMoreContainer)
    }
  })
}

function loadListingsIntoModule (container) {
  const {
    listingId, moreFromThisSeller, userSlug, productType, subProductType, subcategory, hitsPerPage
  } = container.dataset

  const viewMoreListingsFilters = buildFilters({ listingId, moreFromThisSeller, userSlug, productType, subProductType, subcategory })

  initiateSearch(viewMoreListingsFilters).then(results => {
    // due to Algolia A/B test our hitsPerPage may be overriden so
    // manually limiting the number of hits displayed here
    const hits = results.hits.slice(0, hitsPerPage)
    if (hits.length < 2) {
      container.parentElement?.remove()
    } else {
      const queryID = results.queryID ? results.queryID : ''
      hits.forEach((hit, index) => {
        hit.__position = index + 1
        hit.__queryID = queryID
      })

      renderAndEnableListingTiles(container, hits)
      import(/* webpackChunkName: "carousels" */ '../carousels').then(module => module.initPDPViewMoreCarousel(container))
    }
  })
}
